import { UPDATE_SELECTED_LOCATION,
  UPDATE_PREFILL_MESSAGE,
  UPDATE_OPTIONAL_MESSAGE,
  UPDATE_SELECTED_GANG,
  UPDATE_CHIPS,
  REMOVE_CHIP,
  FETCH_GANGS_FOR_SMS,
  FETCH_LOCATIONS
} from '../../actions/types';

const initState = {
  location: "",
  gang: "",
  prefillMessage: "",
  optionalMessage: "",
  chips: [],
  gangOptions: [],
  locationOptions: []
};


export default function formReducer(state=initState, action) {
  switch (action.type) {
    case UPDATE_SELECTED_LOCATION:
      return {
        ...state,
        location: action.payload.location
      };
    case UPDATE_PREFILL_MESSAGE:
      return {
        ...state,
        prefillMessage: action.payload
      }
    case UPDATE_OPTIONAL_MESSAGE:
      return {
        ...state,
        optionalMessage: action.payload
      }
    case UPDATE_SELECTED_GANG:
      return {
        ...state,
        gang: action.payload.gang
      }
    case UPDATE_CHIPS:
      return {
        ...state,
        chips: [...state.chips, action.payload]
      }
    case REMOVE_CHIP:
      let newChips = [...state.chips];
      let propToDelete = newChips.findIndex((chip) => chip.id === Number(action.payload));
      newChips.splice(propToDelete,1);
      return {
        ...state,
        chips: newChips
      }
    case FETCH_GANGS_FOR_SMS:
      return {
        ...state,
        gangOptions: action.payload
      }
    case FETCH_LOCATIONS:
      return {
        ...state,
        locationOptions: action.payload
      }
    default:
      return state;
  }
}


/* END */



// WEBPACK FOOTER //
// ./src/reducers/alerts/form_reducer.js